import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import posthog from "posthog-js";
import React, { useState } from "react";

import ResearchStudiesProps from "../types/Research";
import Research from "./svg/Research";

const ResearchStudies = ({
    headline,
    studies,
    treatmentName,
}: ResearchStudiesProps) => {
    const [openSection, setOpenSection] = useState<number | null>(null);

    const toggleSection = (index: number) => {
        posthog?.capture("research_study_section_toggled", {
            treatmentName,
            sectionTitle: studies[index].title,
            sectionOpen: openSection === index,
        });
        setOpenSection(openSection === index ? null : index);
    };

    return (
        <div className="">
            <div className="flex flex-col lg:flex-row gap-8 relative w-full">
                {/* Left side - Accordion */}
                <div className="lg:w-9/12 z-10">
                    <h2 className="text-[#333333] dark:text-white text-3xl md:text-5xl font-semibold font-satoshi uppercase mb-12 leading-tight">
                        {headline}
                    </h2>

                    <div className="flex flex-col gap-8">
                        {studies.map((study, index) => (
                            <div
                                key={index}
                                className="border-b border-[#1a5b77] dark:border-blue-300/50"
                            >
                                <button
                                    onClick={() => toggleSection(index)}
                                    className="w-full flex justify-between items-start py-4 text-left gap-4"
                                    aria-label="Toggle Section"
                                >
                                    <h3 className="text-[#1a5b77] dark:text-blue-300 text-xl md:text-2xl font-medium font-satoshi leading-relaxed">
                                        {study.title}
                                    </h3>
                                    <div className="text-[#1a5b77] dark:text-blue-300 shrink-0 mt-1">
                                        {openSection === index ? (
                                            <ChevronUpIcon className="h-6 w-6" />
                                        ) : (
                                            <ChevronDownIcon className="h-6 w-6" />
                                        )}
                                    </div>
                                </button>

                                {openSection === index && study.content && (
                                    <div className="pb-8">{study.content}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right side - Image */}
                <div className="hidden lg:block lg:w-1/2 shrink-0 lg:absolute lg:right-0 lg:top-0 lg:-mr-12 z-0">
                    <Research />
                </div>
            </div>
        </div>
    );
};

export default ResearchStudies;
